/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

class PartListItem extends Component {
  state = {
    mouseOn: false,
  };
  componentDidMount = () => {};
  _onPlay = () => {
    const { contentPartSerial, subPartSerial2, subPartSerial3, onClickPlay } =
      this.props.childProps;

    onClickPlay(contentPartSerial, subPartSerial2, subPartSerial3);
  };
  _toggleMouse = () => {
    const { mouseOn } = this.state;

    this.setState({
      mouseOn: !mouseOn,
    });
  };
  render() {
    const { mouseOn } = this.state;
    const {
      contentPartSerial,

      subTitle,
      img,

      episode,
      currentPartSerial,
      progress,
    } = this.props.childProps;
    return (
      <Fragment>
        {currentPartSerial === contentPartSerial ? (
          <dl className="on">
            <dt>
              {subTitle}
              <div className="lin_bg">
                <div style={{ width: progress + '%' }}></div>
              </div>
            </dt>
            <dd>
              <img src={img} />

              <p>{episode}</p>
            </dd>
          </dl>
        ) : (
          <dl
            className={mouseOn ? 'on2' : null}
            onMouseEnter={this._toggleMouse}
            onMouseLeave={this._toggleMouse}
            style={{ cursor: 'pointer' }}
            onClick={this._onPlay}
          >
            <dt>
              {subTitle}
              <div className="lin_bg"></div>
            </dt>
          </dl>
        )}

        {/*
                <dl>
                    <dt>
                        제1화 .학기말 시험
                        <div className="lin_bg"></div>
                    </dt>
                </dl>
                */}
        {/*
                <div onClick = {this._onPlay}>
                    <div><img src = {img} /></div>
                    <div>{subTitle}</div>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(PartListItem));
